import React, {useEffect, useRef, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import '../transaction-forms.scss';
import {RouteComponentProps} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'app/config/store';
import {getEntity} from '../../../../quotation.reducer';
import moment from 'moment';
import {Storage, translate} from "react-jhipster";
import { getEntitiesByEcertNo as getBursaApiOrderResult } from "app/entities/bursa-api-order-result/bursa-api-order-result.reducer";
import {formatDateToLocal, formatTimeToLocal} from "app/shared/util/date-utils";
import {forceLogoAlignment, resolveAgreementDateAtQuotationTime} from "app/shared/util/quotation-utils";
import {formatCurrency} from 'app/shared/util/currency-utils';
import {getEntitiesByBankId as getBankAgreementDateLogs} from 'app/entities/bank-agreement-date-log/bank-agreement-date-log.reducer';

const logo = "../../../content/images/boubyan-logo.png"

export const TransactionFormsSell = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const quotationEntity = useAppSelector(state => state.quotation.entity);
  const quotationLoading = useAppSelector(state => state.quotation.loading);
  const bursaAPIOrderResultEntities = useAppSelector(state => state.bursaAPIOrderResult.entities);
  const bursaAPIOrderResultLoading = useAppSelector(state => state.bursaAPIOrderResult.loading);
  const bursaAPIOrderResultEntity = bursaAPIOrderResultEntities?.find(br => br.sellingTime !== "");
  const agreementDateLogs = useAppSelector(state => state.bankAgreementDateLog.entities);
  const agreementDateLogsLoading = useAppSelector(state => state.bankAgreementDateLog.loading);

  const captureRef = useRef(null);
  const [isDataReady, setIsDataReady] = useState(false);

  const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
  }

  function separator(str,sep) {
    str = str?.substring(0, str.length-3);
    let output = '';
    for (let i = str?.length; i > 0; i-=2) {
      const ii = i-1;
      if(output) {
          output = str?.charAt(ii-1)+str?.charAt(ii)+sep+output;
      } else {
          output = str.charAt(ii-1)+str.charAt(ii);
      }
    }
    return output;
  }

  function agreementDateFormat(q) {
    const date = resolveAgreementDateAtQuotationTime(q, agreementDateLogs);
    if (!date) {
      return '-';
    }
    if (Storage.session.get('locale') === 'en') {
      return moment(date).format('DD/MM/yyyy');
    } else {
      return moment(date).format('yyyy/MM/DD');
    }
  }

  const generatePDFArabic = async () => {
    const element = captureRef.current;

    if (!element) {
      console.error('Element ref is null, cannot generate PDF');
      return;
    }

    // Increase the scale factor to improve image resolution
    const scale = 4; // Increase scale factor to improve resolution
    const canvas = await html2canvas(element, { scale });
    const imgData = canvas.toDataURL('image/png');

    // Create a new PDF document
    const pdf = new jsPDF('p', 'pt', 'a4', true);

    // Get dimensions of the PDF page
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    // Calculate dimensions to maintain the aspect ratio
    const imgWidth = canvas.width / scale;
    const imgHeight = canvas.height / scale;
    let width, height;

    if (imgWidth / pdfWidth > imgHeight / pdfHeight) {
      width = pdfWidth;
      height = (imgHeight / imgWidth) * pdfWidth;
    } else {
      height = pdfHeight;
      width = (imgWidth / imgHeight) * pdfHeight;
    }

    // Add the image to the PDF
    pdf.addImage(imgData, 'PNG', 0, 0, width, height);

    // Save the PDF
    if (Storage.session.get('locale') === 'ar-ly') {
      pdf.save(`Transaction_Forms_Sell_${localStorage.getItem("ecertNo")}_ARB.pdf`);
    } else {
      pdf.save(`Transaction_Forms_Sell_${localStorage.getItem("ecertNo")}_ENG.pdf`);
    }
  };

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  useEffect(() => {
    dispatch(getBursaApiOrderResult(quotationEntity?.bursaAPIStbCert?.ecertNo));
  }, [quotationEntity]);

  useEffect(() => {
    if (quotationEntity?.bank?.id) {
      dispatch(getBankAgreementDateLogs(quotationEntity.bank.id));
    }
  }, [quotationEntity?.bank?.id]);

  // New useEffect to manage data readiness
  useEffect(() => {
    const isLocalCommodity = quotationEntity?.commodity?.isActive === true && quotationEntity?.commodity?.ownership === 'Local';

    if (!quotationLoading && quotationEntity && !agreementDateLogsLoading) {
      if (isLocalCommodity) {
        // For local commodity, we don't need to wait for bursa API
        setIsDataReady(true);
      } else {
        // For non-local commodity, wait for bursa API to complete
        if (!bursaAPIOrderResultLoading) {
          setIsDataReady(true);
        }
      }
    }
  }, [quotationLoading, quotationEntity, bursaAPIOrderResultLoading, bursaAPIOrderResultEntity, agreementDateLogsLoading]);


  useEffect(() => {

    // Only generate PDF when data is ready
    if (!isDataReady) return;

    // jspdf html to pdf directly
    const element = document.getElementById('contentToPrint');

    const pdf = new jsPDF('p', 'pt', 'a4', true);
    const template = new jsPDF('p', 'pt', 'a4', true);
    pdf.setDisplayMode("fullpage", "continuous", "FullScreen");
    const width = pdf.internal.pageSize.getWidth();
    const height = pdf.internal.pageSize.getHeight();

    // sleep to wait for the certificate to fully render
    sleep(800)
      .then(() => {
        // create template to count number of page
        template.html(element, {
          html2canvas: {
            scale: 0.75,
            letterRendering: true,
            backgroundColor: null,
          },
          margin: [0, 0, 20, 0],
          autoPaging: true,
        })
          .then(() => {
            html2canvas(element, {allowTaint: true, useCORS: true, logging: true}).then((canvas) => {

              // remove excess blank pages
              let pageCount = template.getNumberOfPages();
              for (let i = 0; i < 7; i++) {
                template.deletePage(pageCount);
                pageCount--;
              }

              // get number of pages
              pageCount = template.getNumberOfPages();

              // put background into each page before adding content
              for (let i = 1; i <= pageCount; i++) {
                pdf.addPage();
                pdf.setPage(i);

                // change in x or y changes the position of the image
                // change in width or height stretches the image
                // set opacity
                pdf.saveGraphicsState();
                pdf.setGState(pdf.GState({opacity: 0.5}));
                pdf.restoreGraphicsState();
              }

              // set content opacity
              pdf.setPage(1);
              pdf.saveGraphicsState();
              pdf.setGState(pdf.GState({opacity: 1}));
              // create content from html
              pdf.html(element, {
                html2canvas: {
                  scale: 0.75,
                  letterRendering: true,
                  backgroundColor: null,
                },
                // margin needs to be adjusted to ensure that the pages are cut correctly
                margin: [0, 0, 20, -106],
                autoPaging: true,
              }).then(() => {
                // save the pdf
                generatePDFArabic();
              });
            });
          });
      });
  }, [isDataReady, Storage.session.get('locale')]);

  useEffect(() => {
    if (!isDataReady) return;
    forceLogoAlignment('contentToPrint');
  }, [isDataReady, Storage.session.get('locale')]);

  const isLocalCommodity = quotationEntity?.commodity?.isActive === true && quotationEntity?.commodity?.ownership === 'Local';

  // Show loading state while data is not ready
  if (!isDataReady) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <div ref={captureRef} id="contentToPrint" className="boubyan-transaction-forms" style={{position: 'relative',
      width: '795px',
      height: '1123px',
      overflow: 'hidden',
      boxShadow: '0 0 40px rgba(0, 0, 0, 0.2)',
      backgroundColor: 'transparent',
      margin: '20px auto'}}
      >

      <div className="head-content-margin logo-header">
        <img src={logo} className="boubyan-logo"/>
      </div>

      <div className={Storage.session.get('locale') === 'ar-ly' ? "main-content-margin-arabic" : "main-content-margin"}>
        <div>
          <div className="body-content">
            <h6 className="title-text">{translate('comexApp.quotation.transactionForms.title.sell')}</h6>
            <br/>
            <div>
              <table className="table-1">
                <tbody>
                <tr>
                  <td>{translate('comexApp.quotation.transactionForms.table1.date')}</td>
                  <td>{isLocalCommodity ? moment(quotationEntity?.localCommodityStbCert?.valueDate).format(Storage.session.get('locale') === 'en' ? 'DD/MM/yyyy' : 'yyyy/MM/DD')
                    : formatDateToLocal(quotationEntity?.bursaAPIStbCert?.sellingTimeDate)}</td>
                </tr>
                <tr>
                  <td>{translate('comexApp.quotation.transactionForms.table1.time')}</td>
                  <td>{isLocalCommodity
                    ? moment(quotationEntity?.localCommodityStbCert?.createdDate).local().format('HH:mm:ss')
                    : bursaAPIOrderResultEntity?.id !== undefined ?
                      formatTimeToLocal(bursaAPIOrderResultEntity?.sellingTime)
                      :
                      moment(quotationEntity?.bursaAPIStbCert?.createdDate).local().format('HH:mm:ss')
                  }
                  </td>
                </tr>
                <tr>
                  <td>{translate('comexApp.quotation.transactionForms.table1.from')}</td>
                  <td>{translate('comexApp.quotation.transactionForms.boubyanValue')}</td>
                </tr>
                <tr>
                  <td>{translate('comexApp.quotation.transactionForms.table1.to')}</td>
                  <td>{quotationEntity?.bank?.name}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <br/>

            <div className="greeting-table-wrapper">
              <div className="greeting-text pb-2">
              <span className={Storage.session.get('locale') === 'ar-ly' ? "greetings-arabic" : "greetings"}>
                <strong>{translate('comexApp.quotation.transactionForms.greetings.opening')}</strong><br/>
                {translate('comexApp.quotation.transactionForms.greetings.boubyan', {date: agreementDateFormat(quotationEntity)})}
              </span>
              </div>
              <div>
                <table
                  className={Storage.session.get('locale') === 'ar-ly' ? "table-2 table-sell arabic" : "table-2 table-sell"}
                  style={Storage.session.get('locale') === 'ar-ly' ? {direction: 'rtl'} : {}}>
                  <tbody>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.transactionReference')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>
                      {isLocalCommodity
                        ? quotationEntity?.localCommodityStbCertId === null ? "-" : quotationEntity?.localCommodityStbCert?.ecertNo
                        : quotationEntity?.bursaAPIStbCertId === null ? "-" : quotationEntity?.bursaAPIStbCert?.ecertNo
                      }
                    </td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.saleExecutionDate')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{isLocalCommodity
                      ? moment(quotationEntity?.localCommodityStbCert?.valueDate).format(Storage.session.get('locale') === 'en' ? 'DD/MM/yyyy' : 'yyyy/MM/DD')
                      : formatDateToLocal(quotationEntity?.bursaAPIStbCert?.sellingTimeDate)
                    }</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.fromAccount')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{quotationEntity?.customer?.name}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.toAccount')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{translate('comexApp.quotation.transactionForms.bursaValue')}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.itemType')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{quotationEntity?.commodity?.name}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.itemDescription')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{quotationEntity?.description}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.purchasingPrice')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{formatCurrency(quotationEntity?.commodityUnitPrice?.toLocaleString(), quotationEntity?.buyCurrency)}</td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.quantity')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>
                      {formatCurrency(
                        (() => {
                          const vol = quotationEntity?.bursaAPIStbCert?.pVolume;
                          if (vol && String(vol).trim() !== '') {
                            // Display exact value without rounding
                            return String(vol);
                          }
                          return quotationEntity?.commodityQuantity?.toLocaleString();
                        })(),
                        quotationEntity?.commodityUnit
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>{translate('comexApp.quotation.transactionForms.table2.totalAmount')}</td>
                    <td style={{
                      direction: 'ltr',
                      textAlign: Storage.session.get('locale') === 'ar-ly' ? 'right' : 'left'
                    }}>{formatCurrency(quotationEntity?.amount?.toLocaleString(), quotationEntity?.buyCurrency)}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br/><br/><br/><br/>

            <div className="footer-text">
              <h5 className="company-text">{Storage.session.get('locale') === 'ar-ly' ? 'بوبيان كابيتال' : 'Boubyan Capital'}</h5>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default TransactionFormsSell;
